export const hiddenStrategies: Record<string, string[]> = {
  '0x6e84a6216eA6dACC71eE8E6b0a5B7322EEbC0fDd': [
    '0x888fC8d90177a4097e196EF6BBDc7d2e8CfFDb17',
  ],
};
